module.exports = __webpack_public_path__ + "media/icons/editing-99cce8be.png";